import { memo, useCallback } from 'react';

import { useShortIdContext } from '@air/provider-short-id';

import { PreviousAndNextNavigationArrows } from '~/components/AssetModalV2/Header/components/PreviousAndNextNavigationArrows';
import { useGoToPublicAssetPage } from '~/hooks/useGoToPublicAssetPage';
import { usePublicMediaPlayerData } from '~/swr-hooks/mediaPlayer/usePublicMediaPlayerData';

export const PublicAssetNavigationArrows = memo(() => {
  const { shortId } = useShortIdContext();
  const { loadMore, nextAsset, previousAsset, isNearEnd } = usePublicMediaPlayerData(shortId);
  const { goToAssetPage } = useGoToPublicAssetPage();

  const onPreviousClick = useCallback(() => {
    if (previousAsset) {
      goToAssetPage({
        asset: previousAsset,
        isAssetModalAlreadyOpen: true,
      });
    }
  }, [goToAssetPage, previousAsset]);

  const onNextClick = useCallback(() => {
    if (nextAsset) {
      goToAssetPage({
        asset: nextAsset,
        isAssetModalAlreadyOpen: true,
      });
      if (isNearEnd) {
        loadMore();
      }
    }
  }, [goToAssetPage, isNearEnd, loadMore, nextAsset]);

  return (
    <PreviousAndNextNavigationArrows
      onNextClick={nextAsset ? onNextClick : undefined}
      onPreviousClick={previousAsset ? onPreviousClick : undefined}
    />
  );
});

PublicAssetNavigationArrows.displayName = 'PublicAssetNavigationArrows';
